import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { it } from '@angular/core/testing/src/testing_internal';

@Injectable({
  providedIn: 'root'
})
export class BankService  extends BaseService{

  private url = "api/bank";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }



  /** 根据编码查询国家 */
  getBankByCountryCode(countryCode:string):Observable<any> {
    const url = `${this.getUrl()+"/bank"}/${countryCode}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${countryCode}`)),
      catchError(this.handleError<any>(`getany code=${countryCode}`))
    );
  }


  saveToSap(ids):Observable<any> {
    const url = `${this.getUrl()}/saveToSap`;
    return this.http.get<any>(url, {params: {ids: ids}}).pipe(
      tap(_ => this.log(`resend`)),
      catchError(this.handleError<any>(`resend`))
    );
  }


}
